var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "popper",
    {
      staticClass: "js-popper",
      class: "s-" + _vm.id,
      attrs: {
        trigger: "hover",
        options: {
          placement: _vm.position,
          modifiers: { offset: { offset: "0,8px" } },
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "popper popcorn-tooltip",
          class: { "is-click": _vm.isClick },
          attrs: { role: "tooltip" },
        },
        [_vm._v("\n    " + _vm._s(_vm.tooltip) + "\n    "), _vm._t("tooltip")],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "popcorn",
          attrs: { slot: "reference", "aria-describedby": "tooltip" },
          on: { click: _vm.hinted },
          slot: "reference",
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }